import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class ShieldBurst extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 30,
            duration: 0,
            energyCost: 40,
            icon: 14,
            trigger: KeyCode.Digit3,
            triggerType: Input.GetKeyDown,
            info: `Emergency Shield Burst (30s cooldown) - Instantly heal all teammates for 500HP`
        })
    }

    onUse(): void {
        this.player.Heal(500);
        
        const players = this.player.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team === this.player.team
        );

        for (const player of players) {
            this.player.engine.sendHealPacket(player, 500);
        }
    }
}